import { Form, Input, Button, Select, InputNumber, message } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { addPlan } from "../../../api/plan";
import { useDispatch } from "react-redux";
import { getAllPlans } from "../../../redux/actions/AllActions";

const { Option } = Select;

const AddPlan = ({
    setAddPlanModel
}) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const onFinish = async (values) => {
        try {
            const response = await addPlan({
                name: values?.name,
                price: values?.price,
                duration: values?.duration,
                planType: values?.planType,
                benefits : values?.benefits
                
            })
            setAddPlanModel(false);
            fetch();
            message.success('Plan created successfully.')
            console.log('the response', response)
        } catch (e) {
            message.error("Add Plan is failed.");

        }
    
    };
    const fetch = async () => {
        dispatch(getAllPlans());
    }


    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ benefits: [""] }}
        >
            <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter the plan name!" }]}
            >
                <Input placeholder="Enter plan name" />
            </Form.Item>

            <Form.Item
                label="Price (₹)"
                name="price"
                rules={[{ required: true, message: "Please enter the price!" }]}
            >
                <InputNumber min={0} style={{ width: "100%" }} placeholder="Enter price" />
            </Form.Item>

            <Form.Item
                label="Duration (In days)"
                name="duration"
                rules={[{ required: true, message: "Please enter the duration!" }]}
            >
                <InputNumber min={1} style={{ width: "100%" }} placeholder="Enter duration" />
            </Form.Item>

            <Form.Item
                label="Plan Type"
                name="planType"
                rules={[{ required: true, message: "Please select a plan type!" }]}
            >
                <Select placeholder="Select Plan Type">
                    <Option value="Franchise">Franchise</Option>
                    <Option value="SellYourBusiness">SellYourBusiness</Option>
                    <Option value="Dealership">Dealership</Option>
                    <Option value="Investor">Investor</Option>
                </Select>
            </Form.Item>


            <Form.Item label="Benefits">
                <Form.List name="benefits">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <div key={key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                                    <Form.Item
                                        style={{width : "90%"}}
                                        {...restField}
                                        name={name}
                                        rules={[{ required: true, message: "Please enter a benefit!" }]}
                                    >
                                        <Input
                                           
                                            
                                            placeholder="Enter benefit" />
                                    </Form.Item>
                                    <MinusCircleOutlined
                                        style={{
                                            
                                            height : "30px"
                                        }}
                                        onClick={() => remove(name)} />
                                </div>
                            ))}
                            <Button
                                style={{
                              
                            }}
                                type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>Add Benefit</Button>
                        </>
                    )}
                </Form.List>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit">Submit</Button>
            </Form.Item>
        </Form>
    );
};

export default AddPlan;
